<template>
    <select v-model="proxySelected" :disabled="disabled"
            :class="inputClasses">
        <slot></slot>
    </select>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ['update:selected'],

    props: {
        selected: {
            type: [Array, Boolean, Number, String],
            default: false,
        },
        value: {
            default: null,
        },
        error : {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
    },

    computed: {
        inputClasses() {
            return this.error ? 'block w-full mt-1 text-sm border-red-600 dark:text-gray-300 dark:bg-gray-700 focus:border-red-400 focus:outline-none focus:shadow-outline-red form-input'
                : 'block w-full mt-1 text-sm dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 form-select focus:border-red-400 focus:outline-none focus:shadow-outline-red dark:focus:shadow-outline-gray';
        },
        proxySelected: {
            get() {
                return this.selected;
            },

            set(val) {
                this.$emit("update:selected", val);
            },
        },
    },
})
</script>
